import React, { useEffect, useState } from "react";
import Breakpoint, { BreakpointProvider, setDefaultBreakpoints } from "react-socks";
import { Link } from '@reach/router';
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import Identicon from "../commons/Identicon";
import wcConnector from '../../connectors/WalletConnectConnector'
import injected from "../../connectors/InjectedConnector";
import { useWeb3React } from '@web3-react/core';
import { getEllipsisTxt, getSliceLongTxt } from '../../helpers/formatters'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify'
import { useMoralis } from 'react-moralis'

setDefaultBreakpoints([
  { xs: 0 },
  { l: 1199 },
  { xl: 1200 }
]);

const NavLink = props => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? 'active' : 'non-active',
      };
    }}
  />
);

const Header = function () {

  const { account, activate, deactivate, active } = useWeb3React()
  const { Moralis, isInitialized } = useMoralis()
  const [showModel, setShowModel] = useState(false)
  const [showmenu, btn_icon] = useState(false)
  const [isLoginLoading, setIsLoginLoading] = useState(false)
  const [showProfileModal, setShowProfileModal] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [isAdmin, setIsAdmin] = useState(false)
  const [isEnterKeyPress, setTsEnterKeyPress] = useState(false)


  const [nftOwnerData, setNftOwnerData] = useState({})
  const [isProfileDataLoading, setIsProfileDataLoading] = useState(false)

  const saveCreator = async (walletAddress, username = '', bio = '', userImage = null) => {
    try {
      const Creators = Moralis.Object.extend("Creators");
      const query = new Moralis.Query(Creators);
      query.matches('walletAddress', walletAddress, 'i')
      const result = await query.find()
      if (result && result.length === 0) {
        const creator = new Creators()
        creator.set('walletAddress', walletAddress)
        creator.set('username', username)
        creator.set('bio', bio)
        creator.set('userImage', userImage)
        await creator.save()
      }
    } catch (error) {
      console.error('MORALIS ERROR : error while saving user', error)
    }
  }

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return getSliceLongTxt(moralisAttributes.username, 60)
      } else {
        return getEllipsisTxt(moralisAttributes.walletAddress, 7)
      }
    } else {
      return getEllipsisTxt(account || '', 7)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (account && isInitialized && active) {
      // checkIsAdmin(account).then(res => {
      //   console.log('res', res);
      // })
      await saveCreator(account)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, isInitialized, active])


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (account && isInitialized && active) {
      // checkIsAdmin(account).then(res => {
      //   console.log('res', res);
      // })
      await getTokenCreatorProfile(account)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, isInitialized, active])


  const getTokenCreatorProfile = async (walletAddress) => {
    try {
      setIsProfileDataLoading(true)
      const params = { walletAddress };
      const profileDataResponse = await Moralis.Cloud.run("getCreatorDetailsByAddress", params);
      setNftOwnerData(profileDataResponse)
      setIsProfileDataLoading(false)
    } catch (error) {
      setIsProfileDataLoading(false)
      console.error("MORALIS ERROR while fetching profile data ", error)
    }
  }


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const adminAddressLowerCase = []
    const adminAddress = process.env.REACT_APP_ADMIN_ADRS.split(',')

    if (adminAddress && adminAddress.length > 0) {
      adminAddress.forEach(address => {
        adminAddressLowerCase.push(address.toLowerCase())
      })
    }

    if (account) {
      const currentUserAddress = account.toLowerCase()
      const result = adminAddressLowerCase.includes(currentUserAddress)
      if (result) {
        setIsAdmin(true)
      } else {
        setIsAdmin(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  const toggleModal = () => {
    if (showModel) {
      setShowModel(false)
    } else {
      setShowModel(true)
    }
  }

  const disconnect = async () => {
    try {
      window.localStorage.removeItem('userData')
      window.localStorage.removeItem('walletconnect')
      deactivate()
      setShowProfileModal(false)

      toast.warn('You have been logout', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    } catch (error) {
      setShowProfileModal(false)
      console.error("Error while deactivating user : ", error)
    }
  }

  const toggleProfileModal = () => {
    if (showProfileModal) {
      setShowProfileModal(false)
    } else {
      setShowProfileModal(true)
    }
  }



  const connectWithMetamask = async () => {
    try {
      setIsLoginLoading(true)
      await activate(injected)
      const loginDetails = {
        provider: "injected",
        isLoggedIn: true
      }
      window.localStorage.setItem('userData', JSON.stringify(loginDetails))
    } catch (error) {
      const loginDetails = {
        provider: "injected",
        isLoggedIn: false
      }
      window.localStorage.setItem('userData', JSON.stringify(loginDetails))
      console.error('error connecting to metamask ', error)
    } finally {
      setIsLoginLoading(false)
      setShowModel(false)
    }
  }
  const connectWithWalletConnect = async () => {

    try {
      setIsLoginLoading(true)
      await activate(wcConnector)
      const loginDetails = {
        provider: "walletconnect",
        isLoggedIn: true
      }
      window.localStorage.setItem('userData', JSON.stringify(loginDetails))
    } catch (error) {
      const loginDetails = {
        provider: "walletconnect",
        isLoggedIn: false
      }
      window.localStorage.setItem('userData', JSON.stringify(loginDetails))
      console.error('error connecting to wallet-connect ', error)
    } finally {
      setIsLoginLoading(false)
      setShowModel(false)
    }

  }


  useEffect(() => {
    const header = document.getElementById("myHeader");
    const totop = document.getElementById("scroll-to-top");
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
      btn_icon(false);
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
        totop.classList.add("show");

      } else {
        header.classList.remove("sticky");
        totop.classList.remove("show");
      } if (window.pageYOffset > sticky) {
        // closeMenu();
      }
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);

  const closeProfileModal = () => {
    toggleProfileModal(false)
  }

  const onSearchTyping = (e) => {
    setSearchValue(e.target.value);

    if (e.keyCode === 13) {
      setTsEnterKeyPress(true)
      console.log('isEnterKeyPress', isEnterKeyPress);
    }
  }

  return (
    <header id="myHeader" className='navbar white'>
      <div className='container'>
        <div className='row w-100-nav'>
          <div className='logo px-0'>
            <div className='navbar-title navbar-item'>
              <NavLink to="/">
                <img
                  src="/img/H4GMP.png"
                  className="header-logo"
                  alt="#"

                />
                <img
                  src="/img/logo.png"
                  className="header-logo-mobile"
                  alt="#"
                />
                <img
                  src="/img/logo-light.png"
                  className="img-fluid d-none"
                  alt="#"
                />
              </NavLink>
            </div>
          </div>

          <div className='search'>
            <Link to={isEnterKeyPress ? `search/${searchValue}` : ``}>
              <input id="quick_search" className="xs-hide" name="quick_search" placeholder="search item here..." type="text" onKeyUp={e => onSearchTyping(e)} />
            </Link>
            <Link to={`search/${searchValue}`} className="search-button">
              <i className="fa fa-search"></i>
            </Link>
          </div>

          <BreakpointProvider>
            <Breakpoint l down>
              {showmenu &&
                <div className='menu'>
                  <div className='navbar-item'>
                    <a href={process.env.REACT_APP_NFT_MINTING_SITE_URL} target="_blank" rel="noreferrer">
                      Mint NFT
                      <span className='lines'></span>
                    </a>
                  </div>
                  <div className='navbar-item'>
                    <NavLink to="/" onClick={() => btn_icon(!showmenu)}>
                      Home
                      <span className='lines'></span>
                    </NavLink>
                  </div>
                  <div className='navbar-item'>
                    <NavLink to="/gallery" onClick={() => btn_icon(!showmenu)}>
                      Gallery
                      <span className='lines'></span>
                    </NavLink>
                  </div>
                  <div className='navbar-item'>
                    <NavLink to={`/profile/${account}`} onClick={() => btn_icon(!showmenu)}>
                      Profile
                      <span className='lines'></span>
                    </NavLink>
                  </div>
                  <div className='navbar-item'>
                    <NavLink to={`/all-collections`} onClick={() => btn_icon(!showmenu)}>
                      All Collections
                      <span className='lines'></span>
                    </NavLink>
                  </div>
                  {
                    isAdmin ? (
                      <div className='navbar-item'>
                        <NavLink to={`/admin/${account}`} onClick={() => btn_icon(!showmenu)}>
                          Admin
                          <span className='lines'></span>
                        </NavLink>
                      </div>
                    ) : ''
                  }

                </div>
              }
            </Breakpoint>

            <Breakpoint xl>
              <div className='menu'>
                <div className='navbar-item'>
                  <a href={process.env.REACT_APP_NFT_MINTING_SITE_URL} target="_blank" rel="noreferrer">
                    Mint NFT
                    <span className='lines'></span>
                  </a>
                </div>
                <div className='navbar-item'>
                  <NavLink to="/" onClick={() => btn_icon(!showmenu)}>
                    Home
                    <span className='lines'></span>
                  </NavLink>
                </div>
                <div className='navbar-item'>
                  <NavLink to="/gallery" onClick={() => btn_icon(!showmenu)}>
                    Gallery
                    <span className='lines'></span>
                  </NavLink>
                </div>
                <div className='navbar-item'>
                  <NavLink to={`/profile/${account}`} onClick={() => btn_icon(!showmenu)}>
                    Profile
                    <span className='lines'></span>
                  </NavLink>
                </div>
                <div className='navbar-item'>
                    <NavLink to={`/all-collections`} onClick={() => btn_icon(!showmenu)}>
                      All Collections
                      <span className='lines'></span>
                    </NavLink>
                  </div>
                {
                  isAdmin ? (
                    <div className='navbar-item'>
                      <NavLink to={`/admin/${account}`} onClick={() => btn_icon(!showmenu)}>
                        Admin
                        <span className='lines'></span>
                      </NavLink>
                    </div>
                  ) : ''
                }
              </div>
            </Breakpoint>
          </BreakpointProvider>

          <div className='mainside'>
            {
              !account ?
                (
                  <div className="btn-main" onClick={toggleModal}>Connect Wallet</div>
                ) :
                (
                  <div className="login-user-avatar" onClick={toggleProfileModal}>
                    <div className="login-container-section">
                      <div className="login-avatar-image">
                        <Identicon size="20" walletAddress={account} className="idention-image" />
                      </div>
                      <div className="logged-user-account-address">
                        {
                          isProfileDataLoading ? (
                            <div className="spinner-grow" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                          ) : (
                            <div>
                              {getUsername(nftOwnerData ? nftOwnerData.attributes : null)}
                            </div>
                          )
                        }
                        
                      </div>
                    </div>

                  </div>
                )
            }
          </div>

          <Modal
            isOpen={showProfileModal}
            toggle={() => toggleProfileModal()}
            className='modal-dialog-centered'
          >
            <ModalHeader toggle={() => toggleProfileModal()}>
              <div className="connect-modal-title">Account - {getUsername(nftOwnerData ? nftOwnerData.attributes : null)}</div>
              <span className='build-version'>Build Version 1.0</span>
            </ModalHeader>
            <ModalBody className='login-model-body'>
              <div className='profile-action-container'>

                <NavLink to={`/profile/${account}`}>
                  <div className="profile-edit-btn" onClick={closeProfileModal}>
                    <div className="btn-rounded" >
                      View Profile
                    </div>
                  </div>
                </NavLink>
                <div className="profile-logout-btn" onClick={disconnect}>
                  <div className="btn-rounded">
                    Logout
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>



          <Modal
            isOpen={showModel}
            toggle={() => toggleModal()}
            className='modal-dialog-centered'
          // modalClassName={item.modalColor}
          >
            <ModalHeader toggle={() => toggleModal()}>
              <div className="connect-modal-title">Connect Your Wallet</div>
              <span className='build-version'>Build Version 1.0</span>
            </ModalHeader>
            <ModalBody className='login-model-body'>

              <div className='connector-select-container'>
                <div className='metamask-connector' onClick={connectWithMetamask}>
                  {
                    isLoginLoading ? (
                      <div className='metamask-login-btn'>
                        <div className="spinner-grow" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className='metamask-login-btn'>
                        <div className='logo'>
                          <img src='/img/metamask.svg' alt="Login with metamask" />
                        </div>
                        <div className='value'>
                          Login With Metamask
                        </div>
                      </div>
                    )
                  }
                </div>

                <div className='walletconnect-connector' onClick={connectWithWalletConnect}>
                  {
                    isLoginLoading ? (
                      <div className='walletconnect-login-btn'>
                        <div className="spinner-grow" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className='walletconnect-login-btn'>
                        <div className='logo'>
                          <img className="walletconnect-logo" src='/img/wallet-connect.svg' alt="Login with walletconnect" />
                        </div>
                        <div className='value'>
                          Login With Walletconnect
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>

            </ModalBody>

          </Modal>

        </div>

        <button className="nav-icon" onClick={() => btn_icon(!showmenu)}>
          <div className="menu-line white"></div>
          <div className="menu-line1 white"></div>
          <div className="menu-line2 white"></div>
        </button>

      </div>
      <ToastContainer />
    </header>


  );
}
export default Header;